<div
  class="relative flex flex-col w-full h-full p-2 sm:p-4 md:p-6 lg:p-8 xl:p-10 2xl:p-12 overflow-hidden bg-dashboard-bg">
  <div class="relative z-10 mb-2 sm:mb-3 md:mb-4 lg:mb-6 xl:mb-8 2xl:mb-10">
    <h2
      class="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold text-white tracking-widest uppercase font-tech">
      Work Orders
    </h2>
  </div>

  <!-- Main Content: Metrics + Orders -->
  <div class="relative z-10 flex-1 flex gap-2 sm:gap-3 md:gap-4 lg:gap-6 xl:gap-8 min-h-0">
    <!-- Left Section: Metrics (35%) -->
    <div class="w-[25%] flex flex-col min-h-0">
      <app-performance-metrics-card [metrics]="metrics()"></app-performance-metrics-card>
    </div>

    <!-- Divider -->
    <div class="w-[1px] sm:w-[2px] bg-white/20"></div>

    <!-- Right Section: Orders (65%) -->
    <div class="flex-1 flex flex-col gap-2 min-h-0">
      <!-- Header Row -->
      <div
        class="grid grid-cols-[1fr_20%_1fr] px-2 sm:px-4 md:px-6 lg:px-8 xl:px-10 2xl:px-12 mb-1 sm:mb-2 md:mb-3 lg:mb-4 xl:mb-5 2xl:mb-6">
        <span
          class="text-[#f8fafc] opacity-70 font-black text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl 2xl:text-2xl tracking-tight">
          Work Order
        </span>
        <span
          class="text-[#f8fafc] opacity-70 font-black text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl 2xl:text-2xl tracking-tight">
          Required
        </span>
        <span
          class="text-[#f8fafc] opacity-70 font-black text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl 2xl:text-2xl tracking-tight text-right">
          Progress
        </span>
      </div>

      <!-- Data Rows -->
      <div
        class="flex-1 flex flex-col gap-1 sm:gap-2 md:gap-3 lg:gap-4 xl:gap-5 2xl:gap-6 overflow-y-auto min-h-0 custom-scrollbar"
        [@staggerSlideIn]="animationTrigger()">
        @for (order of orders(); track order.workOrderNumber) {
        <div
          class="bg-dashboard-panel px-2 sm:px-4 md:px-6 lg:px-8 xl:px-10 2xl:px-12 py-1.5 sm:py-2 md:py-3 lg:py-4 xl:py-5 2xl:py-6 flex-1 grid grid-cols-[1fr_20%_1fr] items-center rounded-lg sm:rounded-xl md:rounded-2xl lg:rounded-3xl shadow-xl">
          <span
            class="text-dashboard-text font-black text-xs sm:text-sm md:text-lg lg:text-2xl xl:text-3xl 2xl:text-4xl tracking-tight">
            {{ order.workOrderNumber }}
          </span>
          <span
            class="text-dashboard-text font-black text-xs sm:text-sm md:text-lg lg:text-2xl xl:text-3xl 2xl:text-4xl tracking-tight">
            {{ order.requiredLbs }}
          </span>
          <span
            class="text-dashboard-text font-black text-xs sm:text-sm md:text-lg lg:text-2xl xl:text-3xl 2xl:text-4xl tracking-tight text-right">
            {{ order.progress }}
          </span>
        </div>
        }
      </div>
    </div>
  </div>
</div>